import React from "react";
import { Box } from "@mui/material";
import { tokens, monoFamily } from "../theme";
import { isIdentifier, displayValue, isEmptyValue } from "../utils/fieldDisplay";

/**
 * One fact on a record being read.
 *
 * A detail view is not a disabled form. Rendering a read-only record as greyed
 * out inputs says "you may not type here" when the answer is "you are not
 * typing" — it puts a box, a border and a dropdown arrow around every value,
 * and a placeholder where an empty field should say nothing at all.
 *
 * `field` is the stored key, not the label: identifiers are monospace, and
 * deciding that from the key means a screen adding a row does not have to
 * remember a flag.
 */
const RecordField = ({ label, value, field, children }) => {
  const empty = children == null && isEmptyValue(value);
  const mono = Boolean(field) && isIdentifier(field) && !empty;

  return (
    <Box>
      <Box
        sx={{
          fontSize: "0.6875rem",
          fontWeight: 600,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: tokens.textMuted,
          mb: "0.3125rem",
        }}
      >
        {label}
      </Box>
      <Box
        sx={{
          fontFamily: mono ? monoFamily : "inherit",
          fontSize: mono ? "0.8125rem" : "0.875rem",
          color: empty ? tokens.textPlaceholder : tokens.text,
          wordBreak: "break-word",
          minHeight: "1.25rem",
        }}
      >
        {children != null ? children : displayValue(value)}
      </Box>
    </Box>
  );
};

export default RecordField;
